/**
 * The client's clock anchored to the server's. Every battle fetch carries `serverTime`; the
 * offset it implies is what the timeline math runs on, so a shopper whose laptop clock is a
 * minute off still sees round N at the server's boundary. The latest fetch wins. Events carry no
 * time, so fetches are the only anchor.
 */
let offsetMs = 0;

export function captureServerTime(iso: string, localNowMs = Date.now()): void {
  const serverMs = Date.parse(iso);
  if (Number.isNaN(serverMs)) return;
  offsetMs = serverMs - localNowMs;
}

/** Epoch ms as the server would read it now. */
export function serverNow(localNowMs = Date.now()): number {
  return localNowMs + offsetMs;
}

/** The current offset, for tests and diagnostics. */
export function serverClockOffsetMs(): number {
  return offsetMs;
}
